import { Button } from "@deliverr/ui";
import { ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { OutboundModal } from "./OutboundModal";

export const UnrecognizedTrackingCodeModal: React.FC = () => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.scanGaylord.unrecognizedTrackingTitle" defaultMessage="Remove package" />}
      text={
        <FormattedMessage
          id="sortation.scanGaylord.unrecognizedTrackingBody"
          defaultMessage={"This barcode is unrecognized. Scan again or place into exceptions pile."}
        />
      }
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <Button block onClick={() => hideModal(OutboundModal.UNRECOGNIZED_TRACKING_CODE)}>
        <FormattedMessage id="sortation.scanGaylord.understandConfirm" defaultMessage="I understand" />
      </Button>
    </ModalTemplate>
  );
};
